import { createContext } from 'react'

export const TableMatchContext = createContext<{ offsets: number[]; length: number; activeOffset?: number } | null>(null)
